import type {FeatureType, DemoType} from "@/views/landing/components/types";
import {TabletSmartphone, Chrome, Cog, Cpu, Code2, Dribbble, CheckCheck, BadgeHelp} from "lucide-vue-next";
import type {FooterItemType} from "@/types/layout";
import {addOrSubtractDaysFromDate} from "@/helpers/date-time";

import demo1 from "@/assets/images/anymic/mic.png"
import demo2 from "@/assets/images/anymic/mic.png"
import demo3 from "@/assets/images/anymic/mic.png"
import demo4 from "@/assets/images/anymic/mic.png"
import demo5 from "@/assets/images/anymic/mic.png"

import loginImg from "@/assets/images/anymic/mic.png"
import qrLoginImg from "@/assets/images/anymic/mic.png"
import registerImg from "@/assets/images/anymic/mic.png"
import lockScreenImg from "@/assets/images/anymic/mic.png"
import forgotPWImg from "@/assets/images/anymic/mic.png"
import logoutImg from "@/assets/images/anymic/mic.png"
import nftArt4 from "@/assets/images/nft/art/4.png";
import avatar1 from "@/assets/images/avatars/img-1.png";
import nftArt5 from "@/assets/images/nft/art/5.png";
import avatar3 from "@/assets/images/avatars/img-3.png";
import nftArt6 from "@/assets/images/nft/art/6.png";
import avatar4 from "@/assets/images/avatars/img-4.png";
import nftArt7 from "@/assets/images/nft/art/7.png";
import avatar5 from "@/assets/images/avatars/img-5.png";
import nftArt8 from "@/assets/images/nft/art/8.png";
import avatar8 from "@/assets/images/avatars/img-8.png";
import nftArt9 from "@/assets/images/nft/art/9.png";
import avatar9 from "@/assets/images/avatars/img-9.png";
import nftArt14 from "@/assets/images/nft/art/14.png";
import avatar10 from "@/assets/images/avatars/img-10.png";
import nftArt22 from "@/assets/images/nft/art/22.png";
import avatar11 from "@/assets/images/avatars/img-11.png";
import avatar2 from "@/assets/images/avatars/img-2.png";
import nftArt10 from "@/assets/images/nft/art/10.png";
import nftArt11 from "@/assets/images/nft/art/11.png";
import nftArt12 from "@/assets/images/nft/art/12.png";
import nftArt19 from "@/assets/images/nft/art/19.png";

import categorySports from "@/assets/images/categories/category-sports.jpg";
import categoryESports from "@/assets/images/categories/category-esports.jpg";
import categoryMusic from "@/assets/images/categories/category-music.jpg";
import categoryNews from "@/assets/images/categories/category-news.jpg";

import footballImg from "@/assets/images/categories/category-music.jpg";
import basketballImg from "@/assets/images/categories/category-music.jpg";
import tennisImg from "@/assets/images/categories/category-music.jpg";


export const features: FeatureType[] = [
    {
        icon: TabletSmartphone,
        title: "Full Matchmaking Platform",
    },
    {
        icon: Chrome,
        title: "Cross-browser compatible"
    },
    {
        icon: Cog,
        title: "Easy to customize"
    },
    {
        icon: Cpu,
        title: "Support Announcers on all levels "
    },
    {
        icon: Dribbble,
        title: "Give your events a unique voice"
    },
    {
        icon: CheckCheck,
        title: "Streaming Video and Audio"
    },
    {
        icon: BadgeHelp,
        title: "Ultimate Support"
    },
]


export const browseByCategory = [
    {
        label: 'Sports',
        type: 'sports',
        image: categorySports,
        query: {
            path: '/events',
            query: {
                sk: 0,
                q: JSON.stringify({ type: 'sports' }),
                s: JSON.stringify({ createdAt: -1 })
            }
        },
        /*
        // already working, but I need slower transition and image per subType
        subTypes: [
            { label: 'Soccer', image: footballImg, type: 'soccer' },
            { label: 'Basketball', image: basketballImg, type: 'basketball' },
            { label: 'Tennis', image: tennisImg, type: 'tennis' },
            { label: 'Soccer', image: footballImg, type: 'soccer' },
            { label: 'Basketball', image: basketballImg, type: 'basketball' },
            { label: 'Tennis', image: tennisImg, type: 'tennis' },
            { label: 'Soccer', image: footballImg, type: 'soccer' },
            { label: 'Basketball', image: basketballImg, type: 'basketball' },
            { label: 'Tennis', image: tennisImg, type: 'tennis' },
            // Add up to 9
        ]
        */
    },
    {
        label: 'eSports',
        type: 'eSport',
        image: categoryESports,
        query: {
            path: '/events',
            query: {
                sk: 0,
                q: JSON.stringify({ type: 'eSports' }),
                s: JSON.stringify({ createdAt: -1 })
            }
        }
    },
    {
        label: 'Music',
        type: 'music',
        image: categoryMusic,
        query: {
            path: '/events',
            query: {
                sk: 0,
                q: JSON.stringify({ type: 'music' }),
                s: JSON.stringify({ createdAt: -1 })
            }
        }
    },
    /*
    {
        label: 'News',
        type: 'news',
        image: categoryNews,
        query: {
            path: '/events',
            query: {
                sk: 0,
                q: JSON.stringify({ type: 'news' }),
                s: JSON.stringify({ createdAt: -1 })
            }
        }
    },
    */
]

interface FAQType {
    question: string;
    answer: string;
}

export const faqs: FAQType[] = [
    {
        question: 'How do I get started?',
        answer: 'Simply register on the platform.<br><br>' +
            'As an <span class="text-primary">announcer</span>, you can join onboarding events to get familiar with the process.<br>' +
            'As a <span class="text-anymic-gold font-semibold">broadcaster/club</span>, you can also create onboarding events to test the setup.<br>' +
            'For step-by-step instructions, check out our <a class="underline" href="/pages/howto" target="_blank" rel="noopener noreferrer">How-To Guide</a>.'
    },
    {
        question: 'Will the platform support my language?',
        answer: 'The platform interface is currently available in English, but support for additional languages will be added gradually through future updates.<br><br>' +
            'As for events, broadcasters can specify a preferred language for announcers. Only announcers who match this language requirement will be able to apply or be invited — making sure the commentary is in the intended language.'
    },
    {
        question: 'What is the difference between announcers and broadcasters?',
        answer: '<span class="text-primary">Announcers</span> provide the audio commentary — they join events and send their audio stream to the broadcaster.<br><br>' +
            '<span class="text-anymic-gold font-semibold">Broadcasters</span> (such as media organizations or sports clubs) create events, provide the video stream, and receive audio streams from announcers.'
    },
    {
        question: 'What is the difference between an event and a channel?',
        answer: 'An <span class="underline">event</span> is a specific occasion created by a broadcaster, where announcers can apply to join or be invited. It defines the overall context — such as the topic, timing, and type of broadcast — but no connections are active yet.<br><br>' +
            'A <span class="underline">channel</span> is created only when there is a mutual agreement — either the announcer accepts an invitation, or the broadcaster accepts an application. Each channel represents a one-to-one connection between the broadcaster and an announcer within the event.<br>' +
            'Within a channel, the broadcaster defines the video stream to be shared and the target address for receiving the announcer’s audio stream.'
    },
    {
        question: 'Can I choose whether to approve announcers or let them join freely?',
        answer: 'Yes. You can set up your event with one of two participation/join modes<br>' +
            '1. Handshake: One party sends a request to join, and the other must accept or reject it.<br>' +
            '2. Open: The broadcaster creates an event and the announcers one can join without any request or acceptance.'
    },

    {
        question: 'What streaming software and formats are supported?',
        answer: 'You can stream to AnyMic using OBS Studio, Streamlabs, or any other software that supports SRT (Secure Reliable Transport) as a stream target.<br>' +
            'We also provide our own low-latency, audio-only streaming software: <span class="text-primary">AnyMic-Desktop</span>.<br><br>' +
            'On the viewer side, <span class="text-primary">AnyMic-Viewer</span> supports the following formats:<br><br>' +
            'Streaming protocols: MPEG-DASH and HTTP Live Streaming (HLS)<br>' +
            'File playback: MP4'
    },
    {
        question: 'How do costs and payments work?',
        answer: '<span class="text-primary font-semibold">Announcers</span> can join events for free. They can set their own rates — per hour or per event — and are paid by broadcasters based on the budget defined for each event. Only announcers who are accepted will be paid.<br><br>' +
            '<span class="text-anymic-gold font-semibold">Broadcasters</span> can create events for free. When setting up an event, they define the budget (i.e., how much they\'re willing to pay per announcer). They only pay for announcers who accept or are accepted into the event.<br><br>' +
            '<span class="text-anymic-blue font-semibold">AnyMic</span> charges broadcasters based on the number of <span class="font-semibold">active channels</span>. An active channel is either:<br>' +
            'a) A request sent by a <span class="text-anymic-gold font-semibold">broadcaster</span> that is accepted by an <span class="text-primary font-semibold">announcer</span>, or<br>' +
            'b) An application from an <span class="text-primary font-semibold">announcer</span> that is accepted by a <span class="text-anymic-gold font-semibold">broadcaster</span>.'
    },
    {
        question: 'How is security handled?',
        answer: '<span class="text-primary font-semibold">Announcers</span> only see and hear what the <span class="text-anymic-gold font-semibold">broadcaster</span> explicitly shares with them. Each announcer has access only to their own designated channel and cannot see or interact with other announcers in the same event.<br>' +
            'The broadcaster, on the other hand, can manage all channels within an event and control what is visible or audible to each announcer individually.<br><br>' +
            'Streams are sent directly from announcers to the broadcaster\'s endpoint (e.g., via SRT using OBS, AnyMic-Desktop, or other compatible tools).<br>' +
            'There are no intermediary AnyMic servers involved in the audio or video transmission — ensuring privacy and low latency, even though the setup is not peer-to-peer in the strict technical sense.<br>' +
            'This applies only to active channels, where a connection between announcer and broadcaster has been mutually accepted.'
    },
]

export const footerItems: FooterItemType[] = [
    {
        title: 'What and Who',
        links: [
            {
                label: 'Events',
                route: {
                    name: 'events'
                }
            },
            {
                label: 'Announcers',
                route: {
                    name: 'announcers'
                }
            },
            {
                label: 'Broadcasters',
                route: {
                    name: 'providers'
                }
            }
        ]
    },
    {
        title: 'Legal',
        links: [
            {
                label: 'Imprint',
                route: {
                    name: 'pages.imprint'
                }
            },
            {
                label: 'Privacy Policy',
                route: {
                    name: 'pages.privacy'
                }
            },
            {
                label: 'Terms & Conditions',
                route: {
                    name: 'pages.terms'
                }
            },
        ]
    },
    {
        title: 'Resources',
        links: [
            {
                label: 'How it works',
                route: {
                    name: 'pages.howto'
                }
            },
            {
                label: 'Blog',
                route: {
                    url: 'https://blog.anymic.de'
                }
            },
            {
                label: 'Suggestions',
                route: {

                }
            },
            /*
            {
                label: 'Newsletter',
                route: {}
            },

             */
        ]
    },
    {
        title: 'Company',
        links: [
            {
                label: 'About',
                route: {
                    name: 'company'
                }
            },
            {
                label: 'Careers',
                route: {

                }
            },
            {
                label: 'Contact',
                route: {
                    name: 'pages.contact'
                }
            }
        ]
    },
]
